import React, { useState } from 'react';

import styled from '@emotion/styled';

import HetheraLogo from '../../../components/CompanyLogo/HetheraLogo';
import { ISecondStepResponse } from '../../../models/auth/signIn.model';
import PasskeyStep from './PasskeyStep';
import SignInForm from './SignInForm';
import SignInWrapper from './SignInWrapper';

const SignIn = () => {
  // The second-step ticket stays in this component's state only (ops spec K step 11).
  const [step, setStep] = useState<ISecondStepResponse | null>(null);
  const enroll = step?.second_step === 'enroll';
  return (
    <Container>
      <FormArea>
        <FormSection>
          <Brand>
            <HetheraLogo size={40} />
          </Brand>
          <FormBody>
            <SignInWrapper
              formHeaderTitle={step ? (enroll ? 'Set up your passkey' : 'Confirm it’s you') : 'Welcome back to Hethera'}
              formHeaderDescription={
                step
                  ? enroll
                    ? 'Your account has no passkey yet. Open the enrollment link you were given to add one.'
                    : 'Password accepted.'
                  : 'Login to your registered Hethera admin account'
              }
            >
              {step && !enroll ? (
                <PasskeyStep ticket={step.ticket} onBack={() => setStep(null)} />
              ) : step ? (
                <Back type='button' onClick={() => setStep(null)}>
                  Back to sign in
                </Back>
              ) : (
                <SignInForm onSecondStep={setStep} />
              )}
            </SignInWrapper>
          </FormBody>
        </FormSection>
      </FormArea>
    </Container>
  );
};

export default SignIn;

// Styled like the website: cream page, the wordmark, a white card.
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: auto;
  background-color: var(--ground);
  gap: 20px;
`;

const Brand = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
`;

const FormArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  flex: 1;
  background-color: transparent;
  overflow: auto;
  padding: 24px 0;
`;

const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;
  width: 100%;
  justify-content: center;
  height: fit-content;
  padding: 0 20px 24px;
`;

const FormBody = styled.div`
  width: 100%;
`;

const Back = styled.button`
  border: 0;
  background: none;
  padding: 0;
  font: inherit;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.greenColor};
  cursor: pointer;
`;
